// 系统语言
export const enumLanguage = {
    '中文简体': 'zh-hans',
    'English': 'en',
    '中文繁體': 'zh-hant',
};